import { Typography } from "@mui/material";
import { StyledTableCell } from "../style";

export default function NumberCell(args) {
  return (
    <StyledTableCell {...args}>
      <Typography variant="body2" color="textSecondary">
        {args.content}
      </Typography>
    </StyledTableCell>
  );
}
